import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';

import SetTitle from '../../components/shared/SetTitle';
import HelpText from '../../components/help/HelpText';

import { adminUser, managerUser, renderErrorWarning, renderErrors } from '../../utilities/Forms.js'
import { request, handleRequestErrors } from '../../helpers/Requests'
import Audits from '../../components/shared/Audits';

class UpdateCustomAttribute extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleRoleMultiCheckbox = this.handleRoleMultiCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  state = {
    name: "",
    location_id: "",
    role_ids: [],

    locations: [],
    roles: [],

    loaded: false,
    rolesLoaded: false,
    locationsLoaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;

    this.setState({[name]: value});
  }

  handleCheckbox(event) {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState({[name]: value});
  }

  handleRoleMultiCheckbox(event) {
    const name = parseInt(event.target.name);
    const value = event.target.checked;

    let role_ids = this.state.role_ids

    if (value === true) {
      if (!role_ids.includes(name)) {
        role_ids.push(name)
      }
    }
    else if (value === false) {
      if (role_ids.includes(name)) {
        let index = role_ids.indexOf(name)
        role_ids.splice(index, 1)
      }
    }

    this.setState({role_ids: role_ids});
  }

  handleSubmit(event) {
    let id = this.props.id;

    const json = JSON.stringify({
      "rota_type": {
        "name": this.state.name,
        "location_id": this.state.location_id,
        "role_ids": this.state.role_ids
      }
    })

    request("PUT", `/v1/a/rota_types/${id}`, json, () => {this.setState({unauthorized:true})})
      .then(data => {
        this.setState({ errors: "" })
        sessionStorage.setItem("updateSuccess", "Rota Type updated successfully!");
        this.props.closeEditPanel()
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))

    event.preventDefault();
  }

  handleDelete(event) {

    request("DELETE", `/v1/a/rota_types/${this.props.id}`, "", () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Rota Type deleted successfully!`);
        this.props.closeEditPanel()
      })
      .catch(error => {handleRequestErrors(this, error)})

    event.preventDefault();
  }

  renderSaveButton() {
    if (adminUser() || managerUser()) {
      return <input type="submit" value="Save" />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  renderDeleteButton() {
    if (adminUser() || managerUser()) {
      return <div className="button float-right red-button" onClick={this.handleDelete}>Delete</div>
    }
  }

  render() {

    const { name, location_id, role_ids, roles, locations, loaded, rolesLoaded, locationsLoaded, unauthorized, errors, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false || rolesLoaded === false || locationsLoaded === false) {
      return <p>Loading ...</p>;
    }

    return (
      <div>
        <SetTitle title={`Edit Rota Type | ${name} | Staff Fulfilment`} />

        <form className="settings big-settings segment-settings" onSubmit={this.handleSubmit}>
          <div className="segment">
            <div className="row">
              <HelpText page={'rota_type'} section={'name'} />

              <label className="column">Name:</label>{ renderErrors(errors, 'name') }
              <input className="column" type="text" name="name" value={name} onChange={this.handleChange} />
            </div>
          </div>

          <div className="segment">
            <div className="row">
              <HelpText page={'rota_type'} section={'location'} />

              <label className="column">Location:</label>{ renderErrors(errors, 'location') }
              <select name="location_id" onChange={this.handleChange} value={location_id}>
                <option value="">Select</option>
                {locations.map((location) => (
                  <option value={location.id} key={location.id}>{location.name}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="segment">
            <div className="row">
              <HelpText page={'rota_type'} section={'roles'} />

              <label className="column">Roles:</label>{ renderErrors(errors, 'role') }
              <table className="checkbox-table">
                <tbody>
                  <tr>
                    <th>Name</th>
                    <th>Use</th>
                  </tr>
                  {roles.map((role) => (
                    <tr key={role.id}>
                      <td>
                        <Link to={`/configuration/roles/${role.id}`}>{role.name}</Link>
                      </td>
                      <td className="center-cell">
                        <input className="column" type="checkbox" data-name={role.name} name={role.id} checked={role_ids.includes(role.id)} onChange={this.handleRoleMultiCheckbox} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="segment">
            { this.renderSaveButton() }
            { this.renderDeleteButton() }
            { renderErrorWarning(errors) }
          </div>
        </form>

        <Audits klass="RotaType" id={this.props.id} />
      </div>
    );
  }

  componentDidMount() {
    const id = this.props.id;

    request("GET", `/v1/a/rota_types/${id}`, "", () => {this.setState({unauthorized:true})})
      .then(data => {
        this.setState({
          name: data.name,
          location_id: data.location_id,
          role_ids: data.role_ids,
          loaded: true
        })
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))

    request("GET", `/v1/a/roles/names_and_ids`, "", () => {this.setState({unauthorized:true})})
      .then(data => this.setState({ roles: data, rolesLoaded: true }))
      .catch(error => handleRequestErrors(this, error, { rolesLoaded: true }))

    request("GET", `/v1/a/locations/names_and_ids`, "", () => {this.setState({unauthorized:true})})
      .then(data => this.setState({ locations: data, locationsLoaded: true }))
      .catch(error => handleRequestErrors(this, error, { locationsLoaded: true }))
  }
}

export default UpdateCustomAttribute;
